export const usersKeys = {
  getAllUser: (
    page: string | undefined,
    pageLimit: string | undefined,
    query: string | undefined,
    roleId: string | undefined,
  ) => ['Users', 'GetAllUsers', query, roleId, page, pageLimit] as const,
  getUserById: (id: string) => ['Users', 'GetUserById', id] as const,
};
